export enum SortOrder {
    Ascending = 'ascending',
    Descending = 'descending',
}
